var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgE9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #21409a;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke: #21409a;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 21,
    cy: 21,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.83,22.08c-.69,.81-1.46,1.42-2.3,1.84s-1.79,.62-2.82,.62-1.89-.19-2.74-.57-1.58-.91-2.2-1.59-1.1-1.48-1.43-2.39-.5-1.87-.5-2.87c0-1.07,.19-2.09,.56-3.05s.91-1.8,1.61-2.51,1.53-1.26,2.49-1.66,2.03-.59,3.2-.59c1.34,0,2.54,.24,3.59,.73s1.94,1.2,2.66,2.13,1.27,2.11,1.66,3.52,.58,3.02,.58,4.81c0,2-.2,3.76-.61,5.29s-1,2.81-1.77,3.84-1.71,1.81-2.79,2.31-2.31,.76-3.69,.76-2.53-.26-3.53-.77-1.76-1.16-2.28-1.92-.78-1.5-.78-2.21c0-.44,.16-.83,.48-1.17s.73-.52,1.23-.52c.46,0,.87,.13,1.23,.38s.64,.64,.83,1.15c.23,.62,.61,1.13,1.14,1.51s1.13,.57,1.8,.57c.59,0,1.16-.15,1.69-.45s.98-.73,1.36-1.28c.75-1.12,1.2-3.08,1.34-5.91Zm-.36-4.78c0-.71-.1-1.36-.29-1.96s-.46-1.12-.81-1.55-.77-.78-1.25-1.03-1.01-.38-1.59-.38c-.99,0-1.83,.42-2.52,1.27s-1.03,1.97-1.03,3.37,.34,2.49,1.03,3.31,1.56,1.23,2.61,1.23c.64,0,1.26-.17,1.85-.51s1.07-.83,1.44-1.48,.55-1.41,.55-2.28Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE9);
export default __webpack_public_path__ + "static/media/E9.49b5e64b1d0b43f91e9a229cd425d6fc.svg";
export { ForwardRef as ReactComponent };